export default {
  name: 'Toast',
  props: {
    message: String,
    visible: Boolean
  },
  data: function data() {
    return {
      autohideInternal: 3500,
      autohideHandle: 0
    };
  },
  methods: {
    startAutoHide: function startAutoHide() {
      var _this = this;
      this.stopAutoHide();
      this.autohideHandle = setTimeout(function () {
        _this.$emit('close');
      }, this.autohideInternal);
    },
    stopAutoHide: function stopAutoHide() {
      clearTimeout(this.autohideHandle);
    },
    manualHideHandler: function manualHideHandler() {
      if (this.visible) {
        this.$emit('close');
      }
    }
  },
  watch: {
    visible: function visible(value) {
      if (value === true) {
        this.startAutoHide();
      } else {
        this.stopAutoHide();
      }
    }
  }
};